exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ImporterLoader{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#f7f8fc;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:999}.ImporterLoader h1{color:#7740f9;margin:64px;text-align:center;line-height:42px}\n", ""]);

// exports
